import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class UpdatePassengerUserCommand extends IRequestCommand<
  ICommandResponse,
  any,
  IUpdatePassengerUserParameters
> {
  constructor(carrierUserId: string, passengerUserId: string) {
    super();
    this._commandType = CommandRequestType.PUT;
    this._commandUrl = 'carriers/{carrierUserId}/passengers/{passengerUserId}';
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      carrierUserId
    );
    this._commandUrl = this._commandUrl.replace('{passengerUserId}', passengerUserId);
  }

  public override setParameters(parameters: IUpdatePassengerUserParameters) {
    this._commandBody = parameters;
  }
}

export interface IUpdatePassengerUserParameters extends ICommandParameters {
  country: string;
  firstName: string;
  lastName: string;
  phone: string;
  email?: string;
  acceptSimultaneousTrip: boolean;
  addresses: any[];
  family: any[];
  enableFamilyGroup: boolean;
  isPaxVip: boolean;
}
